import { gql } from '@apollo/client';

export const UPDATE_PICKUP_APPOINTMENT = gql`
  mutation UpdatePickupAppointment($input: UpdatePickupAppointmentInput!) {
    updatePickupAppointment(input: $input)
  }
`;

export const UPDATE_COMPLETED_PICKUP_APPOINTMENT = gql`
  mutation UpdateCompletedPickupAppointment($input: UpdatePickupAppointmentInput!) {
    updateCompletedPickupAppointment(input: $input)
  }
`;

export interface UpdatePickupAppointmentInput {
  appointmentId: string;
  taskId: string;
  actualParcelCount: number;
  actualParcelUnit: number;
  photosS3KeysJson: string[];
  actualPickupDate: string;
  actualPickupTimeEnd: string;
  cooperationWarehouseId?: string;
  /** BOL 提货单图片 S3 密钥，一单一张 */
  bolS3Key?: string;
  /** 揽收备注：司机现场填写，落在 BOL 的 Notes 栏 */
  driverRemark?: string;
  /** 现场逐件扫描到的运单号；不传表示本次不更新扫描记录 */
  trackingNumbers?: string[];
  /** 无法扫描时司机填写的原因，与运单号同表留痕 */
  unscannableReason?: string;
  /** 扫描时司机 GPS（打开扫描页时取一次，取不到则不传） */
  scanLatitude?: number;
  scanLongitude?: number;
}

export interface UpdatePickupAppointmentVariables {
  input: UpdatePickupAppointmentInput;
}

export interface UpdatePickupAppointmentResponse {
  updatePickupAppointment: boolean;
}

export interface UpdateCompletedPickupAppointmentResponse {
  updateCompletedPickupAppointment: boolean;
} 